import React, { useState } from "react";

const formatDate = (iso) => (iso ? iso.split("T")[0] : null);

const Row = ({ label, children }) =>
	children == null || children === "" ? null : (
		<li>
			{`${label}: `}
			<span className="text-light">{children}</span>
		</li>
	);

const RdapResult = ({ data }) => {
	const [showRaw, setShowRaw] = useState(false);

	const raw =
		data.source === "rdap" && data.rawRdap
			? JSON.stringify(data.rawRdap, null, 2)
			: (data.rawWhois ?? "(no raw response captured)");

	const registrar = data.registrar?.name
		? data.registrar.url
			? `${data.registrar.name} (${data.registrar.url})`
			: data.registrar.name
		: null;

	return (
		<>
			<ul className="no-styling">
				<Row label="Source">{data.source?.toUpperCase()}</Row>
				<Row label="Registrar">{registrar}</Row>
				<Row label="Registry">{data.registry}</Row>
				<Row label="Created">{formatDate(data.creationDate)}</Row>
				<Row label="Updated">{formatDate(data.updatedDate)}</Row>
				<Row label="Expires">{formatDate(data.expirationDate)}</Row>
				<Row label="DNSSEC">
					{data.dnssec ? (data.dnssec.enabled ? "enabled" : "disabled") : null}
				</Row>
				<Row label="Privacy">{data.privacyEnabled ? "redacted" : null}</Row>
				{data.statuses?.map((s, i) => (
					<Row key={`status-${i}`} label="Status">
						{s.status}
						{s.description ? ` — ${s.description}` : ""}
					</Row>
				))}
				{data.nameservers?.map((ns, i) => (
					<Row key={`ns-${i}`} label="Nameserver">
						{ns.host}
					</Row>
				))}
			</ul>

			<button
				type="button"
				className={`expandable ${showRaw ? "open" : ""}`}
				onClick={() => setShowRaw((v) => !v)}
			>
				{showRaw ? "Hide raw response" : "Show raw response"}
			</button>
			{showRaw && <pre>{raw}</pre>}
		</>
	);
};

export default RdapResult;
